export default class SubHeaderEvents {
  static kollektionenBearbeiten = {
    SELECT_FOR_APPROVAL: 'select_for_approval',
    APPROVE_COLLECTIONS: 'approve_collections',
    CANCEL_APPROVAL: 'cancel_approval',
  };
}
